var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{attrs:{"width":_vm.width,"height":_vm.height,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }